/* eslint-disable camelcase */
import React from "react"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import { auditShape } from "utils/propTypeShapes"
import { ACTIVE_STATUS, INACTIVE_STATUS } from "shared/lists/FacilityList/FacilityActiveStatusFilter"
import { AuditedUser } from "shared/audits"
import AuditChangeDetails from "../AuditChangeDetails"

const statusDescription = (auditedChanges, facilityNameInSentence) => {
  const { discarded_at = [] } = auditedChanges
  const statusChanged = Boolean(!!discarded_at[0] !== !!discarded_at[1])

  if (!statusChanged) return null

  const status = discarded_at[1] ? INACTIVE_STATUS : ACTIVE_STATUS

  return (
    <>{`set the ${facilityNameInSentence}'s status to `}<span className="font-semibold">{status}</span></>
  )
}

const FacilityUpdated = ({ audit }) => {
  const { auditedChanges } = audit

  const { nameInSentence: facilityNameInSentence } = useCustomName(FACILITY_KEY)

  const statusDesc = statusDescription(auditedChanges, facilityNameInSentence)

  return (
    <div>
      <span className="block">
        <AuditedUser audit={audit} /> { statusDesc ?? `updated the ${facilityNameInSentence}` }
      </span>
      {
        !statusDesc && (
          Object.entries(auditedChanges).map(([attribute, change]) => (
            <AuditChangeDetails key={attribute} attribute={attribute} change={change} />
          ))
        )
      }
    </div>
  )
}

FacilityUpdated.propTypes = {
  audit: auditShape.isRequired,
}

export default FacilityUpdated
